"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.invertAlpha = exports.getTransparencyFromAssColor = exports.assColorToRgba = exports.rgbaToAssColor = exports.hexToRgba = exports.rgbaToHex = exports.hexToAssColor = exports.assColorToHex = void 0;
var numeral_1 = __importDefault(require("numeral"));
// AABBGGRR to #RRGGBBAA
exports.assColorToHex = function (color) {
    var parts = color.match(/..?/g);
    if (!parts) {
        return "#FFFFFF";
    }
    if (parts.length === 3) {
        var b_1 = parts[0], g_1 = parts[1], r_1 = parts[2];
        return "#" + r_1 + g_1 + b_1 + "FF";
    }
    var a = parts[0], b = parts[1], g = parts[2], r = parts[3];
    // Ass colors have the inverted alpha where FF is transparent and 00 is solid
    var alpha = exports.invertAlpha(a);
    return ("#" + r + g + b + alpha).toUpperCase();
};
// #RRGGBBAA to AABBGGRR
exports.hexToAssColor = function (color) {
    var defaultColor = "00FFFFFF";
    var split = color === null || color === void 0 ? void 0 : color.split("#");
    if (!(split === null || split === void 0 ? void 0 : split[1])) {
        return defaultColor;
    }
    color = split[1].toUpperCase();
    var parts = color.match(/..?/g);
    if (!parts) {
        return defaultColor;
    }
    if (parts.length === 3) {
        var r_2 = parts[0], g_2 = parts[1], b_2 = parts[2];
        return "00" + b_2 + g_2 + r_2;
    }
    var r = parts[0], g = parts[1], b = parts[2], a = parts[3];
    // Ass colors have the inverted alpha where FF is transparent and 00 is solid
    var alpha = exports.invertAlpha(a);
    return ("" + alpha + b + g + r).toUpperCase();
};
exports.rgbaToHex = function (rgba) {
    var alpha = parseInt((rgba.a * 255).toString(), 10);
    var r = (rgba.r | (1 << 8)).toString(16).slice(1);
    var g = (rgba.g | (1 << 8)).toString(16).slice(1);
    var b = (rgba.b | (1 << 8)).toString(16).slice(1);
    var a = (alpha | (1 << 8)).toString(16).slice(1);
    return ("#" + r + g + b + a).toUpperCase();
};
exports.hexToRgba = function (hex) {
    var i = hex[0] === "#" ? 1 : 0;
    var alpha = hex.slice(i + 6, i + 8);
    var r = parseInt(hex.slice(i, i + 2), 16);
    var g = parseInt(hex.slice(i + 2, i + 4), 16);
    var b = parseInt(hex.slice(i + 4, i + 6), 16);
    var a = hex.length - i > 6 ? +numeral_1.default(parseInt(alpha, 16) / 255).format("0.00") : 1;
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
};
exports.rgbaToAssColor = function (rgba) {
    var hex = exports.rgbaToHex(rgba);
    return exports.hexToAssColor(hex);
};
exports.assColorToRgba = function (assColor) {
    var hex = exports.assColorToHex(assColor);
    return exports.hexToRgba(hex);
};
exports.getTransparencyFromAssColor = function (assColor) {
    var a = exports.assColorToRgba(assColor).a;
    return a * 100;
};
exports.invertAlpha = function (a) {
    var invertAlpha = (255 - parseInt(a, 16)).toString(16);
    return invertAlpha.length === 1 ? "0" + invertAlpha : invertAlpha;
};
//# sourceMappingURL=colors.js.map